export var DRAG_ANIMATION_TIME = 100;